import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmailExistsModal = ({
  isOpen,
  email,
  onLogin,
  onContinueWithoutAccount,
  onChangeEmail,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onChangeEmail} />
      <div className="relative w-full max-w-md bg-card rounded-xl border border-border shadow-xl p-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Compte déjà existant</h3>
            <p className="text-sm text-muted-foreground mt-1">
              L&apos;adresse <span className="font-medium text-foreground">{email}</span> est déjà associée à un compte.
            </p>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-6">
          Connectez-vous pour reprendre votre réservation avec vos informations, continuez sans créer de compte, ou utilisez une autre adresse email.
        </p>

        <div className="flex flex-col gap-2">
          <Button
            variant="default"
            iconName="LogIn"
            iconPosition="left"
            onClick={onLogin}
            fullWidth
          >
            Se connecter et reprendre la réservation
          </Button>
          <Button
            variant="outline"
            iconName="UserX"
            iconPosition="left"
            onClick={onContinueWithoutAccount}
            fullWidth
          >
            Continuer sans créer de compte
          </Button>
          <Button
            variant="ghost"
            iconName="Mail"
            iconPosition="left"
            onClick={onChangeEmail}
            fullWidth
          >
            Utiliser une autre adresse email
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailExistsModal;
